import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components
import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Description from "@mui/icons-material/Description";
import PlayArrow from "@mui/icons-material/PlayArrow";

// core components
import Button from "../components/Button.jsx";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import { TiposInstalacionReserva, TipoEncuenta } from '../othelloConstantes.jsx';

import OthelloFooter from '../componentsothello/OthelloFooter.jsx';

import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDButton from "../components/MDButton";

export default function EncuestasJuegos({ ...props })
{
    const { literal } = props;

    const navigate = useNavigate();

    const { search } = useLocation();

    const [modoEncuestas, setModoEncuestas] = React.useState(false);    
    const [modoficha, setmodoficha] = React.useState(false);   

    const [loading, setLoading] = React.useState(true);    
     
    const [data, setdata] = React.useState(null);

    const [encgrupojuegoselected, setencgrupojuegoselected] = React.useState(null);
    const [id_encgrupojuegoselected, setid_encgrupojuegoselected] = React.useState(0);

    const [infoextraerror, setinfoextraerror] = useState("");
    
    const location = useLocation();

    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);

        let agrupacion = params.get('id');
        
        getDataPageEncuestasJuegos(agrupacion);
    }, [loading]);
   

    const getDataPageEncuestasJuegos = (agrupacion) => {

        let esmodoencuestas = location.pathname.includes("formulario/encuestas");

        var jsonData = JSON.stringify({ modoencuestas: esmodoencuestas, agrupacion: agrupacion });

        fetch('api/Data/GetEncuestasJuegosAgrupados', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(data =>
        {
            if (data != null && data.encuestasGrupo != null)
            {
                setdata(data);

                if (agrupacion != null && agrupacion != "") {
                    setmodoficha(true);

                    if (data.encuestasGrupo.length>0)
                        setencgrupojuegoselected(data.encuestasGrupo[0])
                }
            }
            else
            {
                setdata(null);
                setinfoextraerror(data);
            }

            setLoading(false);

            setModoEncuestas(esmodoencuestas);   

        }).catch(error => {
            setdata([]);
        });       
    }

    const pasoAtras = () => {
        setencgrupojuegoselected(null);
        setid_encgrupojuegoselected(0);
    }

    const onClickEncuestaJuegoPlay = (opc) => {
        if (opc != null && opc.urlEncuesta) {
            window.open(opc.urlEncuesta, '_blank');
        }
    }

    const onVerEncuesta = (opc) => {
        if (opc != null) {
            setid_encgrupojuegoselected(0);
            setencgrupojuegoselected(opc);
        }
    }    

    const getNavegacionPaso = (onBack) => {
        return <MDBox
            sx={{
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'right',
                width: '100%',
                position: 'relative',
                marginTop: 0.5,
                paddingTop: 2,
                paddingBottom: 2,
                borderTop: '1px solid #e0e0e0',
                borderBottom: '1px solid #e0e0e0',
                backgroundColor: '#fafafa',
                pr: 3
            }}
        >
            <Button color="secondary" onClick={onBack}>Volver</Button>
        </MDBox>
    }

    function renderGetIcono(tipo) {

        if (tipo == TipoEncuenta.Normal)
            return <Description fontSize="large" />
        else if (tipo == TiposInstalacionReserva.Juego)
            return <PlayArrow  fontSize="large" />       
        else
            return "";
    }

    function renderEncuestaSelected()
    {
        if (encgrupojuegoselected != null)
        {

            let encjuegoselected = null;

            //Si tenemos un index valido
            if (encgrupojuegoselected.encuestas != null && encgrupojuegoselected.encuestas.length > 0 && encgrupojuegoselected.encuestas.length > id_encgrupojuegoselected)
            {
                let idiomasbotones = [];

                encgrupojuegoselected.encuestas.forEach((x, idx) =>
                {
                    idiomasbotones.push(<MDButton
                        key={idx}
                        variant={idx === id_encgrupojuegoselected ? "contained" : "outlined"}
                        color="info"
                        size="small"
                        sx={{ fontWeight: 'bold' }}
                        onClick={() => setid_encgrupojuegoselected(idx)}
                    >
                        {x.idioma != null && x.idioma !== "" ? x.idioma : "ES"}
                    </MDButton>
                    )
                });               

                encjuegoselected = encgrupojuegoselected.encuestas[id_encgrupojuegoselected];

                return (
                    <MDBox p={3}> {/* Espacio alrededor de todo el contenido */}
                        <Grid container spacing={3}>
                            {/* Columna izquierda: imagen */}
                            <Grid item xs={12} md={6}>
                                <MDBox
                                    component="img"
                                    src={encjuegoselected.image}
                                    alt={encjuegoselected.nombre}
                                    sx={{
                                        width: '100%',
                                        maxWidth: 450,
                                        height: 'auto',
                                        maxHeight: 694, // basado en proporción 700x1080
                                        objectFit: 'contain',
                                        borderRadius: 2,
                                        display: 'block',
                                        margin: '0 auto',
                                    }}
                                />
                            </Grid>

                            {/* Columna derecha: contenido */}
                            <Grid item xs={12} md={6} sx={{ position: 'relative' }}>
                                {/* Idioma arriba a la derecha */}
                                <MDBox sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'flex-end', mb: 2 }}>
                                    {idiomasbotones}
                                </MDBox>
                                {/*<MDBox sx={{ position: 'absolute', top: 0, right: 0, m: 1 }}>*/}
                                {/*    <MDButton variant="contained" color="light" size="small" sx={{ fontWeight: 'bold' }}>*/}
                                {/*        {encjuegoselected.idiomas?.join(" | ") || "ES"}*/}
                                {/*    </MDButton>*/}
                                {/*</MDBox>*/}
                                {/* Contenido principal */}
                                <MDBox sx={{ px: 3, py: 2 }}>
                                    <MDTypography variant="h4" fontWeight="bold" mb={1}>
                                        {encjuegoselected.nombre}
                                    </MDTypography>
                                    {/* Descripción más pequeña */}
                                    <MDTypography variant="body2" color="text" mb={2} sx={{ fontSize: "0.9rem" }}>
                                        {encjuegoselected.descripcion}
                                    </MDTypography>
                                    <MDTypography variant="subtitle2" color="text" fontWeight="medium" mb={2}>
                                        {encjuegoselected.tieneQuestions || 0} preguntas
                                    </MDTypography>
                                    {/*<MDBox mb={2}>*/}
                                    {/*    <MDTypography variant="subtitle2" fontWeight="bold">Preguntas</MDTypography>*/}
                                    {/*    <MDTypography variant="body2" color="text">*/}
                                    {/*        {encjuegoselected.tieneQuestions || 0} preguntas   */}
                                    {/*    </MDTypography>*/}
                                    {/*</MDBox>*/}
                                    {/*<MDBox mb={4}>*/}
                                    {/*    <MDTypography variant="subtitle2" fontWeight="bold">Punto de inicio</MDTypography>*/}
                                    {/*    <MDTypography variant="body2" color="text">*/}
                                    {/*        En el lugar que tú decidas.*/}
                                    {/*    </MDTypography>*/}
                                    {/*</MDBox>*/}

                                    <MDBox mt={2}>
                                        <MDButton
                                            variant="contained"
                                            color="info"
                                            size="large"
                                            fullWidth
                                            onClick={() => onClickEncuestaJuegoPlay(encjuegoselected)}
                                        >
                                            {modoEncuestas ? "Iniciar" : "Jugar"}
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                );
            }
            else
                return ".";
        } else {
            return "";
        }
    }


    function renderEncuestaJuego(encuestrasGrupo, idiomasgrupo) {

        let item = encuestrasGrupo.encuestas[0];

        const hasImage = item?.image && item.image.trim() !== "";

        const idiomas = idiomasgrupo; // idiomasgrupo?.join(' | ') || 'ES';
        const totalPreguntas = item.tieneQuestions || 0;

        return (
            <Grid item xs={12} md={6} lg={4}>
                <MDBox m={1}>
                    <Card
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            height: 400,
                            borderRadius: 3,
                            overflow: "hidden",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                            transition: "all 0.3s ease",
                            '&:hover': {
                                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                                transform: "translateY(-2px)",
                            },
                        }}
                    >
                        {/* Imagen lateral */}
                        <MDBox
                            sx={{
                                width: "40%",
                                height: "100%",
                                backgroundImage: hasImage ? `url(${item.image})` : "none",
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundColor: hasImage ? "transparent" : "#f0f0f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {!hasImage && renderGetIcono(item.tipo)}
                        </MDBox>

                        {/* Contenido lateral derecho */}
                        <MDBox
                            sx={{
                                width: "60%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                backgroundColor: "#ffffff",
                            }}
                        >
                            {/* Contenido superior: título + descripción */}
                            <MDBox sx={{ p: 2, flexGrow: 1 }}>
                                <MDTypography
                                    variant="h5"
                                    fontWeight="bold"
                                    textTransform="capitalize"
                                    sx={{ mb: 1, color: "#1f2937" }}
                                >
                                    {item.nombre}
                                </MDTypography>

                                <MDTypography
                                    variant="body2"
                                    sx={{ fontSize: 14, color: "#4b5563" }}
                                >
                                    {item.descripcion}
                                </MDTypography>
                            </MDBox>

                            {/* BLOQUE INFERIOR (idiomas + botones) */}
                            <MDBox>
                                {/* Info de idiomas y preguntas */}
                                <MDBox
                                    sx={{
                                        backgroundColor: "#f3f4f6",
                                        px: 2,
                                        py: 1.2,
                                        borderTop: "1px solid #e5e7eb",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <MDTypography variant="body2" fontWeight="500" sx={{ color: "#374151" }}>
                                        Idiomas: {idiomas}
                                    </MDTypography>
                                    <MDTypography variant="body2" fontWeight="500" sx={{ color: "#374151" }}>
                                        {totalPreguntas} preguntas
                                    </MDTypography>
                                </MDBox>

                                {/* Botones — sin separación */}
                                <MDBox
                                    sx={{
                                        backgroundColor: "#f9fafb",
                                        px: 2,
                                        py: 1.2,
                                        display: "flex",
                                        gap: 1,
                                        borderTop: "1px solid #e5e7eb", // separador fino
                                    }}
                                >
                                    <MDButton
                                        variant="outlined"
                                        color="info"
                                        fullWidth
                                        size="medium"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onVerEncuesta(encuestrasGrupo);
                                        }}
                                    >
                                        Ver
                                    </MDButton>
                                    <MDButton
                                        variant="contained"
                                        color="info"
                                        fullWidth
                                        size="medium"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onClickEncuestaJuegoPlay(item);
                                        }}
                                    >
                                        {modoEncuestas ? "Iniciar" : "Jugar"}
                                    </MDButton>
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </Card>
                </MDBox>
            </Grid>
        );
    }

    function renderEncuestasJuegos(dato) {

        let finales = dato != null && dato.encuestasGrupo != null && dato.encuestasGrupo.length > 0 ? dato.encuestasGrupo.map(x => renderEncuestaJuego(x, x.idiomas)) : "Sin Informacion Actualmente";

        return <Grid container>{finales}</Grid>;
    }   

    function renderListaEncuestaJuegos() {

        let paso = "";
        let volver = "";

        if (encgrupojuegoselected != null) {
            paso = renderEncuestaSelected();
            volver = modoficha ? "" :  getNavegacionPaso(pasoAtras);
        }
        else
            paso = renderEncuestasJuegos(data);


        return (
            <Grid item xs={12}>
                {Boolean(data?.imageReservas) && (
                    <Grid container>
                        <Grid item xs={12}>
                            <MDBox
                                component="img"
                                src={data.imageReservas}
                                alt="Banner"
                                sx={{
                                    width: '100%',
                                    height: {
                                        xs: 150,
                                        sm: 180,
                                        md: 250,
                                        lg: 300,
                                        xl: 350
                                    },
                                    objectFit: 'cover',
                                    border: '0.5px solid #eeeeee',
                                    borderRadius: 1,
                                    mb: 2,
                                }}
                            />
                        </Grid>
                    </Grid>
                )}                
                <MDBox px={1}>
                    {volver}
                    {paso}
                </MDBox>
                <br />
            </Grid>
        );
    }

    function renderCargando()
    {
         return <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
                minHeight: 140,
                backgroundColor: "rgba(0, 0, 0, 0.6)",  // Fondo oscuro semi-transparente
                borderRadius: 2,
                padding: {
                    xs: "20px",  // Para dispositivos pequeños (móviles)
                    sm: "20px 40px",  // Para pantallas más grandes
                },
                boxShadow: 2,
                width: "100%", // Asegura que ocupe todo el ancho disponible
                position: "absolute", // Lo coloca sobre la imagen de fondo
                top: "50%", // Centrado verticalmente
                left: "50%",
                transform: "translate(-50%, -50%)", // Ajusta el centro
            }}
        >
            <CircularProgress color="secondary" size={50} sx={{ marginRight: 2 }} />
            <MDTypography variant="body1" color="white" fontWeight="400">
                Cargando...
            </MDTypography>
        </MDBox>
    }

   /* function renderModalFecha(valor) {
        return (<OthelloModalBase titulo="Seleccione Fecha" modo={ModoModal.SinDefinir} open={statefechaModal} onCloseResulModal={othelloModalResulFecha} botones={MessageOthelloBoxButtons.OK}>
            <OthelloTimer label="Fecha" fieldname="fbase" currentvalue={valor != null ? valor : ""} onChange={OnChangeFechaModal} />
        </OthelloModalBase>)
    }*/

    let formulario = loading ? renderCargando() : renderListaEncuestaJuegos()

   // let alerta = alert != null ? <OthelloPopUpResult titulo="" alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    //Tratamos el tema del modal
    let modalfecha = "";

    //Si el estado del modal es distinto de cerrado
   /* if (statefechaModal != DataStateModal.dsClosed)
        modalfecha = renderModalFecha(fechashowvisuali);*/
   
    return <>               
        <Grid container>
        {/*<Grid item xs={12} sm={12} md={12}>*/}
        {/*    {alerta}*/}
        {/*</Grid>*/}
        {modalfecha}
        {formulario}        
        <Grid item xs={12} sm={12} md={12}>
            <OthelloFooter />
            </Grid>            
        </Grid>
        {infoextraerror != "" ? infoextraerror : ""}
        {data != null && data.infoextraerrores != null && data.infoextraerrores != "" ? "-> "+ data.infoextraerrores : ""}
    </>
}

//propTypes = {
//    user: PropTypes.object,    
//    onResultReserva: PropTypes.object
//};